import Fetch from "@/utils/Fetch";
import objectToFormData from "@/utils/ObjectToFormData";

export default {
    namespaced: true,
    state: {
        orderingData: null,
        orderingStep: 'data', //data | delivery | pay
        orderingGeneralInfo: {},
        orderingDeliveryInfo: {},
        orderingPaymentInfo: {},
        deliveryCityId: null,
        deliveryPoints: [],
        orderFilled: false,
        successPopupData: null,
        paymentInfo: null,
        currentOrderNumber: null,
        pickup: {},
        deliveryTypes: [],
        deliveryPrice: {},
        citiesList: [],
    },
    mutations: {
        setOrderingData(state, value) {
            if (state.orderingData) {
                state.orderingData['ORDER_PROP']['delivery'] = value.ORDER_PROP?.delivery;
                state.orderingData['DELIVERY'] = value.DELIVERY;
                state.orderingData['deliveryDate'] = value.deliveryDate;
                state.orderingData['deliveryPriceText'] = value.deliveryPriceText;
                state.orderingData['TOTAL'] = value.TOTAL;
            } else state.orderingData = value
        },
        setOrderingStep(state, step) {
            state.orderingStep = step;
            if (step === 'pay') state.orderFilled = true;
        },
        setOrderingGeneralInfo(state, value) {
            state.orderingGeneralInfo = value;
        },
        setOrderingDeliveryInfo(state, value) {
            state.orderingDeliveryInfo = value;
        },
        setOrderingPaymentInfo(state, value) {
            state.orderingPaymentInfo = value;
        },
        setDeliveryCity(state, value) {
            state.deliveryCityId = value;
        },
        setSuccessPopupData(state, value) {
            state.successPopupData = value;
        },
        setPaymentInfo(state, value) {
            state.paymentInfo = value;
        },
        setCurrentOrderNumber(state, value) {
            state.currentOrderNumber = value;
        },
        setPickup(state, value) {
            state.pickup = value;
        },
        setDeliveryTypes(state, value) {
            state.deliveryTypes = value;
        },
        setDeliveryPrice(state, value) {
            state.deliveryPrice = value;
        },
        setDeliveryPoints(state, value) {
            state.deliveryPoints = value;
        },
        setCitiesList(state, data) {
            if (!data) return
            state.citiesList = data
        },
    },
    getters: {
        getOrderingData: (state) => state.orderingData,
        getOrderingStep: (state) => state.orderingStep,
        getOrderingGeneralInfo: (state) => state.orderingGeneralInfo,
        getOrderingGeneralField: (state) => (field) => state.orderingGeneralInfo[field],
        getOrderingDeliveryInfo: (state) => state.orderingDeliveryInfo,
        getOrderingPaymentInfo: (state) => state.orderingPaymentInfo,
        getOrderingPaymentField: (state) => (field) => state.orderingPaymentInfo[field],
        getOrderFilled: (state) => state.orderFilled,
        getSuccessPopupData: (state) => state.successPopupData,
        getPaymentInfo: (state) => state.paymentInfo,
        getCurrentOrderNumber: (state) => state.currentOrderNumber,
        getOrderingDeliveryLogistic: (state) => state.orderingData?.DELIVERY?.filter(el => el.NAME?.toLowerCase() != 'самовывоз'),
        getOrderingDeliverySelf: (state) => state.orderingData?.DELIVERY?.filter(el => el.NAME?.toLowerCase() == 'самовывоз'),
        getPickup: state => state.pickup,
        getDeliveryTypes: state => state.deliveryTypes,
        getDeliveryPrice: state => state.deliveryPrice,
        getCitiesList: state => state.citiesList,
        getDeliveryPoints: state => state.deliveryPoints,
    },
    actions: {
        async sendOrderData({commit, state}) {
            commit('startLoading', 'sendOrderData', {root: true})

            const formData = {personal_data: {...state.orderingGeneralInfo}, delivery_data: {...state.orderingDeliveryInfo}, payment_data: {...state.orderingPaymentInfo}};
            const body = new objectToFormData(formData);
            console.log(formData)

            let response = await Fetch('cart/create-order/', {
                method: 'POST',
                body
            })
            commit('stopLoading', 'sendOrderData', {root: true})
            return response
        },
        async requestDeliveryPoints({commit, state}) {
            commit('startLoading', 'requestDeliveryPoints', {root: true})

            const body = new objectToFormData({id: state.deliveryCityId});

            let response = await Fetch('catalog/getpointbycity/',
                {
                    method: 'POST',
                    body
                });

            if (response.success) {
                commit('setDeliveryPoints', response.data);
            } else {
                let textError = "Ошибка";
                window.toast.error(textError, response.message || '');
            }
            commit('stopLoading', 'requestDeliveryPoints', {root: true})
            return response;
        },
        async requestPaymentInfo({commit}, {id, ts}) {
            commit('startLoading', 'requestPaymentInfo', {root: true})

            let response = await Fetch(`order/${id}/?ts=${ts}`);

            if (response.success) {
                commit('setPaymentInfo', response.data);
                commit('setCurrentOrderNumber', id);
            } else {
                let textError = "Ошибка";
                window.toast.error(textError, response.message || '');
            }
            commit('stopLoading', 'requestPaymentInfo', {root: true})
            return response;
        },
        async requestPaymentLink({commit}, data) {
            commit('startLoading', 'requestPaymentLink', {root: true})

            const body = new objectToFormData(data);
            let response = await Fetch(`order/payment-link/`, {
                method: 'POST',
                body
            });

            if (!response.success) {
                let textError = "Ошибка";
                window.toast.error(textError, response.message || '');
            }
            commit('stopLoading', 'requestPaymentLink', {root: true})
            return response;
        },
        async requestPaymentStatus({commit}, id) {
            commit('startLoading', 'requestPaymentStatus', {root: true})

            let response = await Fetch(`order/payment/${id}/status/`);

            if (!response.success) {
                let textError = "Ошибка";
                window.toast.error(textError, response.message || '');
            }
            commit('stopLoading', 'requestPaymentStatus', {root: true})
            return response;
        },
        async loadDeliveryListData({commit}) {
            commit('startLoading', 'loadDeliveryListData', {root: true})
            let response = await Fetch('cart/order/service-data/')
            if (response.success) {
                await commit('setPickup', response.data.pickup)
                await commit('setDeliveryTypes', response.data.delivery_types)
            }
            commit('stopLoading', 'loadDeliveryListData', {root: true})
        },
        async loadCitiesList({commit}, query) {
            let response = await Fetch(`/cart/get-cities/?q=${query || ''}`)
            if (response.success) {
                await commit('setCitiesList', response.data)
            }
           
        },

        async loadDeliveryPrice({commit}, data) {
            const body = new objectToFormData(data);

            let response = await Fetch('cart/calc-delivery/', {
                method: 'POST',
                body
            })
            if (response.success) {
                await commit('setDeliveryPrice', response.data)
            }
           
        },
        async loadDeliveryPoints({commit}, data) {
            let response = await Fetch(`cart/get-delivery-points/?type_delivery=${data.type_delivery}&city_id=${data.city_id}`, {
                method: 'GET',
            })
            if (response.success) {
                await commit('setDeliveryPoints', response.data)
            }
        },

    },
    methods: {}
}